import http from '../../../../libs/http'
export default (id) => http.get(`${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/taxes/${id}`)
